import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {
  AppParametricSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../helpers/reselectHelpers';
import {AnswerModel} from '../../../../../models/api/answerModel';
import {fetchAnswersAndFoldersAction} from '../../../../../store/data/answers/answerActions';
import {getSortedAnswers} from '../../../../../store/data/answers/answersSelectors';
import {getUserParticipatingInboxes} from '../../../../../store/data/inboxes/inboxesSelectors';
import {getAvailableUserNamespaces} from '../../../../../store/data/teams/teamsSelectors';
import {QuickResponsesDropdown} from './quickResponsesDropdown';

/*
 * Selectors.
 */

type GetAnswerListSelector = AppParametricSelector<any, ReadonlyArray<AnswerModel>>;

function makeGetAvailableAnswers(getAnswerList: GetAnswerListSelector) {
  return createSelector(
    [getAnswerList, getAvailableUserNamespaces, getUserParticipatingInboxes],
    (answers, namespaces, participatingInboxes) =>
      answers.filter((a) => {
        // The answer needs to be in a namespace our user can access.
        if (!namespaces.includes(a.namespace)) {
          return false;
        }

        // If showInAllInboxes, it should be visible across the entire namespace.
        if (a.showInAllInboxes) {
          return true;
        }

        // We appear to be sending from a teammate's individual inbox,
        // so find any answers with an inbox that the user participates in.
        return a.inboxIds.some((id) => participatingInboxes.some((i) => i.id === id));
      }),
  );
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  fetchAllAnswersAndFolders: fetchAnswersAndFoldersAction,
}));

const mapStateToProps = makeMapStateToProps()(() => ({
  allAnswers: makeGetAvailableAnswers(getSortedAnswers),
}));

export const QuickResponsesDropdownContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuickResponsesDropdown);
